import { OuTypeId } from '@backModels/Ref.OuTypeId';

type OuPositionLike = { positionGuid: string; ouTypeId: number | undefined; isActive: boolean };

/**
 * Adding users to a position from a campaign copies the permissions from that position's node in a
 * Department (OrganizationalUnitPositionUsersController.SaveUserSettings). Without one the save fails
 * with OriginalOuPositionNotFound, so the role needs a warning as soon as it lacks a department node.
 */
/**
 * Department nodes are derived from the campaign roles (save-settings auto-assigns and removes them):
 * they are not a position of their own, so user-facing lists leave them out.
 */
export function isDepartmentNode(pos: Pick<OuPositionLike, 'ouTypeId'>): boolean {
  return pos.ouTypeId === OuTypeId.Department;
}

export function hasDepartmentNode(ouPositions: OuPositionLike[], positionGuid: string): boolean {
  return ouPositions.some(op => op.positionGuid === positionGuid && op.isActive && op.ouTypeId === OuTypeId.Department);
}
